import { PageRow, ErrorSummary, THEME_CONSTANTS as TC } from '@cof/plastic-components';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';

export const mapErrors = (errors, isSubmitted) => {
    const errorsArray = [];
    const iterate = (obj, array) => {
        Object.values(obj).forEach((lowerObj) => {
            if (typeof lowerObj === 'object') {
                if ('ref' in lowerObj) {
                    array.push(lowerObj);
                    return array;
                }
                return iterate(lowerObj, array);
            }
        });
    };
    iterate(errors, errorsArray);
    const equalErrors = { ...errorsArray };
    const mappedErrors = Object.values(equalErrors).map((error) => ({
        message: error?.message || '',
        reference: error?.ref?.name || error?.focusOnClick || ''
    }));
    if (isSubmitted === true) {
        return mappedErrors;
    }
    return [];
};

export const onClickError = (reference) => {
    const domElement =
        document.querySelector(`[name="${reference}"]`) ||
        document.querySelector(`#${reference} button[data-has-error="true"]`) || // For Friction Test modal variant
        document.querySelector(`#${reference} details[data-has-error="true"] summary`); // For Friction Test dropdown variant
    domElement.focus({ preventScroll: true });
    domElement.scrollIntoView({ block: 'center' });
};

const ErrorBox = ({ errorSummaryRef }) => {
    const {
        formState: { errors, isSubmitted }
    } = useFormContext();

    const mappedErrors = mapErrors(errors, isSubmitted);
    useEffect(() => {
        errorSummaryRef.current.focus();
    }, [errorSummaryRef]);

    return (
        <PageRow data-qa-id="ErrorBox-section" style={{ padding: mappedErrors.length !== 0 ? '3.2rem' : '0rem' }}>
            <ErrorSummary
                items={mappedErrors}
                bg={TC.COLORS.global.white}
                ref={errorSummaryRef}
                onClickError={onClickError}
                quantumMetricVisible
            />
        </PageRow>
    );
};
ErrorBox.propTypes = {
    errorSummaryRef: PropTypes.object.isRequired
};
export default ErrorBox;
